import React from 'react';
import { Button, Flex, Grid, Typography, theme } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const COPY_WIDTH_PX = 540;
const GRADIENT_ANGLE_DEG = 78;

export type AnnouncementIllustration = {
  src: string;
  width: number;
  height: number;
};

type AnnouncementBannerProps = {
  title: string;
  body: string;
  illustration: AnnouncementIllustration;
  onDismiss: () => void;
};

function AnnouncementBanner({ title, body, illustration, onDismiss }: AnnouncementBannerProps) {
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();

  return (
    <Flex
      align="center"
      gap={token.margin}
      style={{
        padding: screens.md ? token.sizeXL : token.paddingMD,
        borderRadius: token.borderRadiusLG,
        border: `${token.lineWidth}px solid ${token.colorBorderSecondary}`,
        background: `linear-gradient(${GRADIENT_ANGLE_DEG}deg, ${token.colorBgContainer} 0%, ${token.colorPrimaryBg} 100%)`,
      }}
    >
      <Flex vertical align="flex-start" gap={token.margin} style={{ flex: `0 1 ${COPY_WIDTH_PX}px`, minWidth: 0 }}>
        <Flex vertical>
          <Typography.Text strong style={{ fontSize: token.fontSizeLG, lineHeight: token.lineHeightLG }}>
            {title}
          </Typography.Text>
          <Typography.Text type="secondary">{body}</Typography.Text>
        </Flex>
        <Button type="link" icon={<CloseOutlined />} onClick={onDismiss} style={{ color: token.colorPrimary }}>
          Dismiss
        </Button>
      </Flex>

      {screens.lg && (
        <Flex justify="center" style={{ flex: `1 1 ${illustration.width}px`, minWidth: 0 }}>
          <img
            src={illustration.src}
            alt=""
            aria-hidden="true"
            width={illustration.width}
            height={illustration.height}
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </Flex>
      )}
    </Flex>
  );
}

export default AnnouncementBanner;
